export const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_3f098949-b81f-4501-8783-aaa79a62febc/artifacts/l0o1867x_FB_IMG_1788628135419.jpg";

export const CONTACT = {
  phone: "00962781000110",
  whatsapp: "962781000110",
  address_ar: "عمّان – الأردن، الدوار السابع – شارع عبدالله غوشة",
  address_en: "Amman - Jordan, 7th Circle - Abdullah Ghosheh St.",
  instagram: "https://www.instagram.com/fluorit.realestate",
  facebook: "https://www.facebook.com/share/19uvD39Y18/",
};

export const PROPERTY_TYPES = [
  { key: "land", ar: "أراضٍ", en: "Land", img: "/img/land.png" },
  { key: "apartment", ar: "شقق", en: "Apartments", img: "/img/apartment.png" },
  { key: "villa", ar: "فلل / منازل", en: "Villas / Houses", img: "/img/villa.png" },
  { key: "building", ar: "عمارات", en: "Buildings", img: "/img/building.png" },
  { key: "commercial", ar: "تجاري", en: "Commercial", img: "/img/commercial.png" },
  { key: "industrial", ar: "صناعي", en: "Industrial", img: "/img/industrial.png" },
  { key: "farm", ar: "زراعي / مزارع", en: "Farms / Agricultural", img: "/img/farm.png" },
  { key: "hotel", ar: "فنادق / سياحي", en: "Hotels / Tourism", img: "/img/hotel.png" },
  { key: "other", ar: "أخرى", en: "Other", img: "/img/other.png" },
];

export const HERO_SLIDES = [
  {
    key: "launch",
    img: "/img/banner-1.png",
    title_ar: "ساهم معنا في حملة إطلاق موقع فلوريت عقار",
    sub_ar: "معًا نصل إلى المزيد من فرص العقار في الأردن — الإعلان مجاني خلال فترة الإطلاق.",
    cta_ar: "أعلن عقارك هنا",
    title_en: "Join the FLUORIT launch campaign",
    sub_en: "List your property with us — free during our launch phase.",
    cta_en: "List your property",
    href: "/sell",
    tag_ar: "🚀 حملة إطلاق",
    tag_en: "🚀 Launch campaign",
    accent: "gold",
  },
  {
    key: "invest",
    img: "/img/banner-2.png",
    title_ar: "الاستثمار بالعقار",
    sub_ar: "قرارك اليوم .. قيمة للمستقبل. اكتشف فرصًا عقارية مختارة بعناية.",
    cta_ar: "اكتشف فرص الاستثمار",
    title_en: "Invest in real estate",
    sub_en: "Today's decision. Tomorrow's value. Curated Jordanian opportunities.",
    cta_en: "Explore opportunities",
    href: "/properties",
    tag_ar: "🏡 استثمار عقاري",
    tag_en: "🏡 Investment",
    accent: "emerald",
  },
  {
    key: "ai",
    img: "/img/banner-3.png",
    title_ar: "ابحث عن عقارك… أو اكتشف قيمته",
    sub_ar: "ابحث بذكاء، قارن الفرص، واحصل على تقدير استرشادي لقيمة عقارك — حتى لو لم يكن معروضًا على فلوريت.",
    cta_ar: "جرّب الذكاء العقاري",
    title_en: "Find your property… or discover its value",
    sub_en: "Search smartly, compare opportunities and get an indicative valuation of your property — even if it isn't listed on FLUORIT.",
    cta_en: "Try the AI assistant",
    href: "/ai-property-assistant",
    tag_ar: "🤖 ذكاء فلوريت العقاري",
    tag_en: "🤖 FLUORIT AI",
    accent: "cyber",
  },
];

export const GOVERNORATES = [
  "عمّان","إربد","الزرقاء","المفرق","البلقاء","الكرك","معان","الطفيلة","مأدبا","جرش","عجلون","العقبة",
];

export const AMMAN_CENTER = { lat: 31.9539, lng: 35.9106 };

export function formatPrice(v) {
  if (v === null || v === undefined || v === "") return "-";
  return Number(v).toLocaleString("en-US");
}
